<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7jy7jf/tc-custom/9780547525150.jpg?1705693051405" alt="This image is the cover for the book Great Railway Bazaar"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Great Railway Bazaar
      </h1>
      <p class="bookDescription body article font2">
        <b>The acclaimed author recounts his epic journey across Europe and Asia in this international bestselling classic of travel literature: “Compulsive reading” (Graham Greene).</b><br/>  <br/> In 1973, Paul Theroux embarked on a four-month journey by train from the United Kingdom through Europe, the Middle East, and Southeast Asia. In <i>The Great Railway Bazaar</i>, he records in vivid detail and penetrating insight the many fascinating incidents, adventures, and encounters of his grand, intercontinental tour.<br/>  <br/> Asia's fabled trains—the Orient Express, the Khyber Pass Local, the Frontier Mail, the Golden Arrow to Kuala Lumpur, the Mandalay Express, the Trans-Siberian Express—are the stars of a journey that takes Theroux on a loop eastbound from London's Victoria Station to Tokyo Central, then back from Japan on the Trans-Siberian. Brimming with Theroux's signature humor and wry observations, this engrossing chronicle is essential reading for both the ardent adventurer and the armchair traveler.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Theroux
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cc379288